"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeInputSection = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../styled/styles");
var DateRangeInput_1 = require("./DateRangeInput");
var DateRangeUtils_1 = require("../utils/DateRangeUtils");
var ITypes_1 = require("../type/ITypes");
var moment_1 = __importDefault(require("moment"));
var core_1 = require("@blueprintjs/core");
var DateRangeInputSection = function (props) {
    var state = props.state, format = props.format, disabled = props.disabled, dateType = props.dateType, onClick = props.onClick, upperCaseFormat = props.upperCaseFormat, tipLabels = props.tipLabels, onBlurInputs = props.onBlurInputs, onFocusInputs = props.onFocusInputs, setUpdateOrder = props.setUpdateOrder, updateOrder = props.updateOrder;
    var _a = (0, react_1.useMemo)(function () {
        var _a = DateRangeUtils_1.DateRangeUtils.buildRangeDate(state, dateType), date1 = _a[0], date2 = _a[1];
        var build = function (date) {
            return !!date && (0, moment_1.default)(date).isValid()
                ? DateRangeUtils_1.DateRangeUtils.momentFormatter(date, format !== null && format !== void 0 ? format : ITypes_1.DEFAULT_FORMAT)
                : '';
        };
        var isValid = (!!date1 && (0, moment_1.default)(date1).isValid()) ||
            (!!date2 && (0, moment_1.default)(date2).isValid());
        return isValid ? [build(date1), build(date2)] : ['', ''];
    }, [state]), startDate = _a[0], endDate = _a[1];
    var _b = (0, react_1.useState)(startDate), startDateVal = _b[0], setStartDate = _b[1];
    var _c = (0, react_1.useState)(startDate), endDateVal = _c[0], setEndDate = _c[1];
    (0, react_1.useEffect)(function () {
        setStartDate(startDate);
    }, [startDate]);
    (0, react_1.useEffect)(function () {
        setEndDate(endDate);
    }, [endDate]);
    (0, react_1.useEffect)(function () {
        if (updateOrder) {
            setStartDate(startDate);
            setEndDate(endDate);
            setUpdateOrder === null || setUpdateOrder === void 0 ? void 0 : setUpdateOrder(false);
        }
    }, [updateOrder]);
    return (react_1.default.createElement(styles_1.DateRangeInputSectionStyled, null,
        react_1.default.createElement("div", { style: { flexGrow: 1, paddingRight: '2px' } },
            react_1.default.createElement(DateRangeInput_1.DateRangeInput, { id: 'date-range-input-start-date', format: format, valueField: startDateVal, onClick: onClick === null || onClick === void 0 ? void 0 : onClick(core_1.Boundary.START), disabled: disabled, upperCaseFormat: upperCaseFormat, tipLabel: tipLabels === null || tipLabels === void 0 ? void 0 : tipLabels.start, onBlur: onBlurInputs === null || onBlurInputs === void 0 ? void 0 : onBlurInputs(core_1.Boundary.START), onChange: setStartDate, onFocus: onFocusInputs === null || onFocusInputs === void 0 ? void 0 : onFocusInputs(core_1.Boundary.START) })),
        react_1.default.createElement("div", { style: { flexGrow: 1 } },
            react_1.default.createElement(DateRangeInput_1.DateRangeInput, { id: 'date-range-input-end-date', format: format, valueField: endDateVal, onClick: onClick === null || onClick === void 0 ? void 0 : onClick(core_1.Boundary.END), disabled: disabled, upperCaseFormat: upperCaseFormat, tipLabel: tipLabels === null || tipLabels === void 0 ? void 0 : tipLabels.end, onBlur: onBlurInputs === null || onBlurInputs === void 0 ? void 0 : onBlurInputs(core_1.Boundary.END), onChange: setEndDate, onFocus: onFocusInputs === null || onFocusInputs === void 0 ? void 0 : onFocusInputs(core_1.Boundary.END) }))));
};
exports.DateRangeInputSection = DateRangeInputSection;
